module.exports = __webpack_public_path__ + "img/icon-sku.ac9982ae.png";